<div>
  <div>
    <h1 class="large">Войти</h1>
  </div>
  @if (error) {
    <div class="common-error">
      <img src="icons/error_icon.png" alt="error">
      Произошла ошибка при регистрации: {{ error }}
    </div>
  }
  <div>
    <form #f="ngForm" (ngSubmit)="login(f)">
      <div>
        <input type="email"
               name="email"
               placeholder="Email"
               required
               email
               ngModel
               #email="ngModel">

        @if (email.invalid && (email.touched || email.dirty)) {
          <div class="error">
            Email не валиден
          </div>
        }
      </div>

      <!-- пароль -->
      <div>
        <input type="password"
               name="password"
               placeholder="Пароль"
               required
               ngModel
               appPasswordValidationDirective
               #password="ngModel">

        @if (password.invalid && (password.touched || password.dirty)) {
          <div class="error">
            Пароль должен быть не меньше 8 символов, содержать символы в разном регистре, спецсимволы и цифры
          </div>
        }
      </div>
      <button type="submit"
              class="primary"
              [disabled]="f.invalid">
        Войти
      </button>
    </form>
  </div>
  <div>
    <p>ИЛИ</p>
  </div>
  <div class="oauth-group">
    <button class="oauth-button apple">
      <img src="icons/apple_icon.png" alt="apple" width="20" height="20">
      Войти с Apple
    </button>
  </div>
  <div class="forgot-password-link">
    <a routerLink="/forgot-password">Забыли пароль?</a>
  </div>
  <div class="register-link">
    <p>Нет аккаунта?<p>
    <a routerLink="/register">Зарегистрироваться</a>
  </div>
</div>
